// extracted by mini-css-extract-plugin
export default {"like":"_3pe7O","not-clickable":"_1G89g","notClickable":"_1G89g","likebutton":"_30Fe4","likes":"_37jtL"};